var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"videoElement"},[_c('p',[_vm._v("暂无视频")]),(_vm.url === '')?_c('p',[_vm._v("暂无视频")]):_c('video',{ref:`video${_vm.gateId}`,staticClass:"videoItem",attrs:{"muted":"","autoplay":""},domProps:{"muted":true}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }